export const trackColors: any = {
    root: "hsl(330, 100%, 93%)",
    voxbm: "hsl(0, 100%, 93%)",
    voxdh: "hsl(71, 100%, 93%)",
    meshset: "hsl(120, 100%, 93%)",
    voxsurf: "hsl(187, 100%, 93%)",
};

export const trackColorsGradientStart: any = {
    root: "hsl(330,   50%, 85%)",
    voxbm: "hsl(0,     50%, 85%)",
    voxdh: "hsl(71,    50%, 85%)",
    meshset: "hsl(120,   50%, 85%)",
    voxsurf: "hsl(187,   50%, 85%)",
};

const itemRenderer = ({
    item,
    timelineContext,
    itemContext,
    getItemProps,
    getResizeProps,
    handleItemSelection,
}: any) => {
    const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();

    return (
        <div
            key={"item-" + item.id}
            {...getItemProps({
                onMouseDown: () => {
                    //console.log("on item click", item);
                    handleItemSelection(item);
                },
            })}
        >
            {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}

            <div
                style={{
                    height: "100%",
                    //backgroundColor: itemContext.selected ? "gray" : trackColors[item.trackType.icon],
                    background: itemContext.selected
                        ? //trackColors[item.trackType.icon] :
                          "repeating-linear-gradient(45deg, " +
                          trackColors[item.trackType.icon] +
                          ", " +
                          trackColors[item.trackType.icon] +
                          " 10px, " +
                          trackColorsGradientStart[item.trackType.icon] +
                          " 10px, " +
                          trackColorsGradientStart[item.trackType.icon] +
                          " 20px)"
                        : "linear-gradient(90deg, " +
                          trackColorsGradientStart[item.trackType.icon] +
                          " 0%, " +
                          trackColors[item.trackType.icon] +
                          " 100%)",
                    //backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 15px, rgba(255,255,255,.5) 15px, rgba(255,255,255,.5) 30px)",
                    overflow: "hidden",
                    paddingLeft: 5,
                    marginLeft: 0,
                    textAlign: "center",
                    textOverflow: "ellipsis",
                    width: "calc(100% - 1px)",
                    color: "black",
                    borderColor: "red",
                    borderStyle: "solid",
                    borderWidth: 1,
                    borderRadius: 0,
                    whiteSpace: "nowrap",
                    boxShadow:
                        item.end_time - item.start_time > 10000
                            ? itemContext.selected
                                ? "rgb(0 0 0 / 16%) 6px 6px 24px"
                                : "rgb(0 0 0 / 5%) 6px 6px 10px"
                            : "none",
                }}
            >
                {itemContext.title}
            </div>

            {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
        </div>
    );
};
export default itemRenderer;
